import { bigdataRequest } from './axios'

const baseUrl = '/v1/api/goodsKeyRank/'

export default {
  page(data) {
    return bigdataRequest.get(baseUrl + 'page', { params: data }).then(res => res.data)
  },
  history(data) {
    return bigdataRequest.get(baseUrl + 'history', { params: data }).then(res => res.data)
  }
}
